/**
 * Master list of supported experiments for the application.
 */

export const SHIPPING_IN_CART = {
  experimentKey: 'shipping_quotes_in_cart_v2',
  variationKeys: ['variation_1', 'variation_2'],
  activeVariant: 'variation_2',
};

export const supportedExperiments = [
  {
    experimentKey: 'cart_-_show_shipping_price',
    variationKeys: ['cart_ssp_1', 'cart_ssp_2'],
  },
  {
    experimentKey: 'guest_checkout',
    // variation_1 is control (coag off) and variation_2 is test (coag allowed)
    variationKeys: ['variation_1', 'variation_2'],
  },
  {
    experimentKey: 'save_for_later',
    variationKeys: ['variation_1', 'variation_2'],
  },
  {
    // variation_1 is control
    // variation_2 is mobile user allowed to use express checkout instead of checkoutUI
    experimentKey: 'express_checkout_on_mobile_checkout_cta',
    variationKeys: ['variation_1', 'variation_2'],
  },
  {
    experimentKey: SHIPPING_IN_CART.experimentKey,
    variationKeys: SHIPPING_IN_CART.variationKeys,
  },
];
